// import EFPicture from 'elem/compCommon/EFPicture';
import EcoImg from 'eco-design/base/eco-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getSolarRecommand } from '@/service/solar-calculator';
import { calcEnergyGeneration, calcEnergyStorage, getRecommand } from '@/constants/off-grid';
import { cloneDeep } from 'lodash';
import { Scrollbar, Navigation } from 'swiper';
import EFLight from '@elem/ui-assets/icons/appliances/EFLight';
import EFPhone from '@elem/ui-assets/icons/appliances/EFPhone';
import EFCamera from '@elem/ui-assets/icons/appliances/EFCamera';
import EFFan from '@elem/ui-assets/icons/appliances/EFFan';
import EFProjector from '@elem/ui-assets/icons/appliances/EFProjector';
import EFDrone from '@elem/ui-assets/icons/appliances/EFDrone';
import EFWiFi from '@elem/ui-assets/icons/appliances/EFWiFi';
import EFLaptop from '@elem/ui-assets/icons/appliances/EFLaptop';
import EFRefrigerator from '@elem/ui-assets/icons/appliances/EFRefrigerator';
import EFElectricBlanket from '@elem/ui-assets/icons/appliances/EFElectricBlanket';
import EFCarFridge from '@elem/ui-assets/icons/appliances/EFCarFridge';
import EFDisplay from '@elem/ui-assets/icons/appliances/EFDisplay';
import CoffeeMaker from 'elem/SVGIcon/PowerBackup/CoffeeMaker';
import Microwave from '@elem/SVGIcon/PowerBackup/Microwave';
import AirConditioner from '@elem/SVGIcon/OffGrid/AirConditioner';

export default function E_NA({ callBuy, updateSolar }: any) {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);
    const [open, setOpen] = useState(false);
    const [init1, setInit1] = useState(false);
    const [init2, setInit2] = useState(false);
    const [init3, setInit3] = useState(false);

    const SolarPanels: any = [
        {
            img: `/responsive/picture/common-products/60w.png`,
            quantity: 1,
            isActive: true,
            energy: 45,
            id: '45w',
            title: t('secE_card_45w'),
            cartTitle: t('secE_cart_45w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '7264162676809',
                    ca: '8292312449178',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41731341353033',
                    ca: '52438137438579',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: `/responsive/picture/common-products/60w.png`,
            quantity: 1,
            isActive: true,
            energy: 60,
            id: '60w',
            title: t('secE_card_60w'),
            cartTitle: t('secE_cart_60w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '4478011113545',
                    ca: '7539941834906',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998108401737',
                    ca: '43797586608282',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: `/responsive/picture/common-products/110w.png`,
            quantity: 1,
            isActive: false,
            energy: 110,
            id: '110w',
            title: t('secE_card_110w'),
            cartTitle: t('secE_cart_110w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '4318647222345',
                    ca: '5511642644634',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998109941833',
                    ca: '43725961199770',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: `/responsive/picture/common-products/160w.png`,
            quantity: 1,
            isActive: false,
            energy: 160,
            id: '160w',
            title: t('secE_card_160w'),
            cartTitle: t('secE_cart_160w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '7003543044169',
                    ca: '8066687074458',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41682906218569',
                    ca: '52162328330611',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: `/responsive/picture/common-products/220w_bifacial.png`,
            quantity: 1,
            isActive: false,
            energy: 220,
            id: '220w',
            title: t('secE_card_220w'),
            cartTitle: t('secE_cart_220w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '7003545108553',
                    ca: '7296662896794',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41670394576969',
                    ca: '43874721824922',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: ``,
            quantity: 1,
            isActive: true,
            energy: 'CampingLight',
            id: 'CampingLight',
            title: t('secE_card_CampingLight'),
            cartTitle: t('secE_cart_CampingLight_name'),
            productId: (() => {
                const localMap: any = {
                    us: '6777224101961',
                    ca: '7590554828954',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40023315054665',
                    ca: '42864166273178',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: ``,
            quantity: 1,
            isActive: false,
            energy: 'TRAIL_DC_Series_Bag',
            id: 'TRAIL_DC_Series_Bag',
            title: t('secE_card_Bag'),
            cartTitle: t('secE_cart_Bag_name'),
            productId: (() => {
                const localMap: any = {
                    us: '15376019161161',
                    ca: '15142271648115',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54647146381385',
                    ca: '52813020266867',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
    ];

    const iconMap: any = {
        Light: <EFLight />,
        Phone: <EFPhone />,
        Camera: <EFCamera />,
        Fan: <EFFan />,
        Projector: <EFProjector />,
        Drone: <EFDrone />,
        WiFi: <EFWiFi />,
        Laptop: <EFLaptop />,
        Refrigerator: <EFRefrigerator />,
        ElectricBlanket: <EFElectricBlanket />,
        CarFridge: <EFCarFridge />,
        Display: <EFDisplay />,
        CoffeeMaker: <CoffeeMaker />,
        MicroWave: <Microwave />,
        AirConditioner: <AirConditioner />,
    };

    const [solarpanels, setSolarpanels] = useState(SolarPanels);

    const imgs: { [key: string]: string[] } = {
        T200: [
            'https://websiteoss.ecoflow.com/upload/image/1755768212786/trail200_light.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768212584/trail200_bag.png',
        ],
        T300: [
            'https://websiteoss.ecoflow.com/upload/image/1755768213000/trail300_45w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768213191/trail300_60w.png',
        ],
        river2pro: [
            'https://websiteoss.ecoflow.com/upload/image/1755768209616/r2p_45w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768209874/r2p_110w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768210106/r2p_160w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768210401/r2p_220w.png',
        ],
        river3max: [
            'https://websiteoss.ecoflow.com/upload/image/1755768210595/r3m_45w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768210835/r3m_110w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768211016/r3m_160w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768211337/r3m_220w.png',
        ],
        river3plus: [
            'https://websiteoss.ecoflow.com/upload/image/1755768211629/r3p_45w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768211855/r3p_110w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768212065/r3p_160w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768212287/r3p_220w.png',
        ],
        dp3classic: [
            'https://websiteoss.ecoflow.com/upload/image/1760150064178/d3c_110w.png',
            'https://websiteoss.ecoflow.com/upload/image/1758943947070/d3c_220w.png',
        ],
        dp3plus: [
            'https://websiteoss.ecoflow.com/upload/image/1755768208086/d3p_110w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768208280/d3p_160w.png',
            'https://websiteoss.ecoflow.com/upload/image/1755768208464/d3p_220w.png',
        ],
    };

    const cards: any = [
        {
            img: '',
            power: t('secE_card5_power'),
            title: t('secE_card5_title'),
            id: 'T200',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/trail-series?variant=54553979682889',
                    ca: 'https://ca.ecoflow.com/products/trail-series?variant=52734893490547',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15350808346697',
                    ca: '15127284351347',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54553979682889',
                    ca: '52734893490547',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['secE_card5_desc1', 'secE_card5_desc2', 'secE_card5_desc3'],
            icons: [
                {
                    icon: 'Light',
                    title: 'secE_card5_icon1_title',
                    desc: 'secE_card5_icon1_desc',
                },
                {
                    icon: 'Phone',
                    title: 'secE_card5_icon2_title',
                    desc: 'secE_card5_icon2_desc',
                },
                {
                    icon: 'Camera',
                    title: 'secE_card5_icon3_title',
                    desc: 'secE_card5_icon3_desc',
                },
                {
                    icon: 'Fan',
                    title: 'secE_card5_icon4_title',
                    desc: 'secE_card5_icon4_desc',
                },
                {
                    icon: 'Projector',
                    title: 'secE_card5_icon5_title',
                    desc: 'secE_card5_icon5_desc',
                },
                {
                    icon: 'Drone',
                    title: 'secE_card5_icon6_title',
                    desc: 'secE_card5_icon6_desc',
                },
            ],
            children: SolarPanels.filter((item: any) => ['CampingLight', 'TRAIL_DC_Series_Bag'].includes(item.energy)),
        },
        {
            img: '',
            power: t('secE_card6_power'),
            title: t('secE_card6_title'),
            id: 'T300',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/trail-series?variant=54553980043337',
                    ca: 'https://ca.ecoflow.com/products/trail-series?variant=52734893523315',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15350808346697',
                    ca: '15127284351347',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54553980043337',
                    ca: '52734893523315',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['secE_card6_desc1', 'secE_card6_desc2', 'secE_card6_desc3'],
            icons: [
                {
                    icon: 'Light',
                    title: 'secE_card6_icon1_title',
                    desc: 'secE_card6_icon1_desc',
                },
                {
                    icon: 'Phone',
                    title: 'secE_card6_icon2_title',
                    desc: 'secE_card6_icon2_desc',
                },
                {
                    icon: 'Camera',
                    title: 'secE_card6_icon3_title',
                    desc: 'secE_card6_icon3_desc',
                },
                {
                    icon: 'Fan',
                    title: 'secE_card6_icon4_title',
                    desc: 'secE_card6_icon4_desc',
                },
                {
                    icon: 'Projector',
                    title: 'secE_card6_icon5_title',
                    desc: 'secE_card6_icon5_desc',
                },
                {
                    icon: 'Drone',
                    title: 'secE_card6_icon6_title',
                    desc: 'secE_card6_icon6_desc',
                },
            ],
            children: solarpanels.filter((item: any) => [45, 60].includes(item.energy)),
        },
        {
            img: '/responsive/picture/common-products/river2pro.png',
            power: t('secE_card3_power'),
            title: t('secE_card3_title'),
            id: 'river2pro',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/river-2-pro-portable-power-station?variant=54320636198985',
                    ca: 'https://ca.ecoflow.com/products/river-2-pro-portable-power-station?variant=43725934461082',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6859087282249',
                    ca: '7539942064282',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54320636198985',
                    ca: '43725934461082',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['secE_card3_desc1', 'secE_card3_desc2', 'secE_card3_desc3'],
            icons: [
                {
                    icon: 'Light',
                    title: 'secE_card3_icon1_title',
                    desc: 'secE_card3_icon1_desc',
                },
                {
                    icon: 'Phone',
                    title: 'secE_card3_icon2_title',
                    desc: 'secE_card3_icon2_desc',
                },
                {
                    icon: 'WiFi',
                    title: 'secE_card3_icon3_title',
                    desc: 'secE_card3_icon3_desc',
                },
                {
                    icon: 'Laptop',
                    title: 'secE_card3_icon4_title',
                    desc: 'secE_card3_icon4_desc',
                },
                {
                    icon: 'Refrigerator',
                    title: 'secE_card3_icon5_title',
                    desc: 'secE_card3_icon5_desc',
                },
                {
                    icon: 'ElectricBlanket',
                    title: 'secE_card3_icon6_title',
                    desc: 'secE_card3_icon6_desc',
                },
            ],
            children: solarpanels.filter((item: any) => [45, 110, 160, 220].includes(item.energy)),
        },
        {
            img: ``,
            power: t('secF_card4_power'),
            title: t('secF_card4_title'),
            id: 'dp3plus',
            tag: t('common_card_tag_hot_sale'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-plus-portable-power-station?variant=41826182496329',
                    ca: 'https://ca.ecoflow.com/products/delta-3-plus-portable-power-station?variant=51645140926835',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7289136054345',
                    ca: '8331157766298',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41826182496329',
                    ca: '51645140926835',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['secF_card4_desc1', 'secF_card4_desc2', 'secF_card4_desc3'],
            icons: [
                {
                    icon: 'Light',
                    title: 'secF_card4_icon1_title',
                    desc: 'secF_card4_icon1_desc',
                },
                {
                    icon: 'Phone',
                    title: 'secF_card4_icon2_title',
                    desc: 'secF_card4_icon2_desc',
                },
                {
                    icon: 'CarFridge',
                    title: 'secF_card4_icon3_title',
                    desc: 'secF_card4_icon3_desc',
                },
                {
                    icon: 'CoffeeMaker',
                    title: 'secF_card4_icon4_title',
                    desc: 'secF_card4_icon4_desc',
                },
                {
                    icon: 'MicroWave',
                    title: 'secF_card4_icon5_title',
                    desc: 'secF_card4_icon5_desc',
                },
                {
                    icon: 'AirConditioner',
                    title: 'secF_card4_icon6_title',
                    desc: 'secF_card4_icon6_desc',
                },
            ],
            children: JSON.parse(JSON.stringify([solarpanels[2], solarpanels[3], solarpanels[4]])),
        },
        {
            img: ``,
            power: t('secF_card7_power'),
            title: t('secF_card7_title'),
            id: 'dp3classic',
            tag: t('common_card_tag_hot_sale'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-classic-portable-power-station?variant=54691871227977',
                    ca: 'https://ca.ecoflow.com/products/delta-3-classic-portable-power-station?variant=62060639584627',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15386067730505',
                    ca: '15164532916595',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54691871227977',
                    ca: '62060639584627',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['secF_card7_desc1', 'secF_card7_desc2', 'secF_card7_desc3'],
            icons: [
                {
                    icon: 'Light',
                    title: 'secF_card7_icon1_title',
                    desc: 'secF_card7_icon1_desc',
                },
                {
                    icon: 'Phone',
                    title: 'secF_card7_icon2_title',
                    desc: 'secF_card7_icon2_desc',
                },
                {
                    icon: 'CarFridge',
                    title: 'secF_card7_icon3_title',
                    desc: 'secF_card7_icon3_desc',
                },
                {
                    icon: 'CoffeeMaker',
                    title: 'secF_card7_icon4_title',
                    desc: 'secF_card7_icon4_desc',
                },
                {
                    icon: 'MicroWave',
                    title: 'secF_card7_icon5_title',
                    desc: 'secF_card7_icon5_desc',
                },
                {
                    icon: 'AirConditioner',
                    title: 'secF_card7_icon6_title',
                    desc: 'secF_card7_icon6_desc',
                },
            ],
            children: solarpanels.filter((item: any) => [110, 220].includes(item.energy)),
        },
        // {
        //     img: '',
        //     power: t('secE_card1_power'),
        //     title: t('secE_card1_title'),
        //     id: 'river3max',
        //     link_more: (() => {
        //         const localMap: any = {
        //             us: 'https://us.ecoflow.com/products/river-3-plus-portable-power-station?variant=41636514136137',
        //             ca: 'https://ca.ecoflow.com/products/ecoflow-river-3-plus-extra-battery?variant=52631854416243',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     productId: (() => {
        //         const localMap: any = {
        //             us: '7290968473673',
        //             ca: '15101492822387',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     variantId: (() => {
        //         const localMap: any = {
        //             us: '41636514136137',
        //             ca: '52631854416243',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     descArr: ['secE_card1_desc1', 'secE_card1_desc2', 'secE_card1_desc3'],
        //     icons: [
        //         {
        //             icon: 'Light',
        //             title: 'secE_card1_icon1_title',
        //             desc: 'secE_card1_icon1_desc',
        //         },
        //         {
        //             icon: 'Phone',
        //             title: 'secE_card1_icon2_title',
        //             desc: 'secE_card1_icon2_desc',
        //         },
        //         {
        //             icon: 'WiFi',
        //             title: 'secE_card1_icon3_title',
        //             desc: 'secE_card1_icon3_desc',
        //         },
        //         {
        //             icon: 'Laptop',
        //             title: 'secE_card1_icon4_title',
        //             desc: 'secE_card1_icon4_desc',
        //         },
        //         {
        //             icon: 'Display',
        //             title: 'secE_card1_icon5_title',
        //             desc: 'secE_card1_icon5_desc',
        //         },
        //         {
        //             icon: 'CarFridge',
        //             title: 'secE_card1_icon6_title',
        //             desc: 'secE_card1_icon6_desc',
        //         },
        //     ],
        //     children: solarpanels.filter((item: any) => [45, 110, 160, 220].includes(item.energy)),
        // },
        // {
        //     img: '',
        //     power: t('secE_card2_power'),
        //     title: t('secE_card2_title'),
        //     id: 'river3plus',
        //     link_more: (() => {
        //         const localMap: any = {
        //             us: 'https://us.ecoflow.com/products/river-3-plus-portable-power-station?variant=41636514136137',
        //             ca: 'https://ca.ecoflow.com/products/river-3-plus-portable-power-station?variant=52355185279347',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     productId: (() => {
        //         const localMap: any = {
        //             us: '7290968473673',
        //             ca: '15039583682931',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     variantId: (() => {
        //         const localMap: any = {
        //             us: '41636514136137',
        //             ca: '52355185279347',
        //         };
        //         return localMap[locale] || localMap.us;
        //     })(),
        //     descArr: ['secE_card2_desc1', 'secE_card2_desc2', 'secE_card2_desc3'],
        //     icons: [
        //         {
        //             icon: 'Light',
        //             title: 'secE_card2_icon1_title',
        //             desc: 'secE_card2_icon1_desc',
        //         },
        //         {
        //             icon: 'Phone',
        //             title: 'secE_card2_icon2_title',
        //             desc: 'secE_card2_icon2_desc',
        //         },
        //         {
        //             icon: 'WiFi',
        //             title: 'secE_card2_icon3_title',
        //             desc: 'secE_card2_icon3_desc',
        //         },
        //         {
        //             icon: 'Laptop',
        //             title: 'secE_card2_icon4_title',
        //             desc: 'secE_card2_icon4_desc',
        //         },
        //         {
        //             icon: 'Display',
        //             title: 'secE_card2_icon5_title',
        //             desc: 'secE_card2_icon5_desc',
        //         },
        //         {
        //             icon: 'CarFridge',
        //             title: 'secE_card2_icon6_title',
        //             desc: 'secE_card2_icon6_desc',
        //         },
        //     ],
        //     children: solarpanels.filter((item: any) => [45, 110, 160, 220].includes(item.energy)),
        // },
    ];

    const [cardLists, setCardLists] = useState([]);

    const handleBuy = (card: any) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: card.title,
                position: `Vanlife Roadtrips Page_${card?.title}`,
            });
            // fb埋点
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            const target = card?.children?.find((item: any) => item?.isActive);
            // if (!target?.discountPrice && target?.originalPrice !== 0) {
            //     return;
            // }
            const addCarts: any = [
                {
                    discountPrice: card?.discountPrice,
                    originalPrice: card?.originalPrice,
                    inventory: card?.inventory,
                    productId: card?.productId,
                    variantId: card?.variantId,
                    img: card?.img,
                    title: card?.title,
                },
            ];
            if (target?.quantity) {
                addCarts.push({
                    discountPrice: target?.discountPrice,
                    originalPrice: target?.originalPrice,
                    inventory: target?.inventory,
                    productId: target?.productId,
                    variantId: target?.variantId,
                    img: target?.img,
                    title: target?.cartTitle,
                    quantity: target?.quantity,
                    parentVariantId: target?.parentVariantId,
                });
            }
            callBuy(addCarts);
        }
    };
    const handleClick = (_: any, k: number, m: number) => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        const activeIdx = tempChildren.findIndex((item: any) => item.isActive);
        if (activeIdx < 0) {
            return;
        }
        tempChildren[activeIdx].isActive = false;
        tempChildren[m].isActive = true;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCount = (_: any, num: number, k: number, m: number) => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        tempChildren[m].quantity = num;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCalclate = (card: any, list: any) => {
        card.energy = calcEnergyGeneration(list?.energy, list?.quantity, locale);
        card.storage = calcEnergyStorage(card?.id);
    };

    const setSolarStatu = (item: any, child?: any) => {
        if (!child) {
            child = item?.children?.find((list: any) => list?.isActive);
        }
        if (item.id === 'T200') {
            child.recommand = [1];
        }
        // 推荐状态：0 数量0-置灰 1：推荐 2:不推荐
        if (!child?.recommand && item.id !== 'T200') {
            child.recommand = getRecommand(item.id, child.id);
        }
        item.statu = child?.quantity === 0 ? 0 : child.recommand?.includes(child?.quantity) ? 1 : 2;
    };

    const AddSubtractor = ({ data, callback, k, m }: any) => {
        const NUM_MIN = 0;
        const NUM_MAX = data?.inventory ?? 1000;
        const { useState } = useGlobal();
        const [number, setNumber] = useState(Math.max(0, data?.inventory < data?.quantity ? data?.inventory : data?.quantity ?? 1));

        const reduceNumber = () => {
            if (number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1, k, m);
        };

        const addNumber = () => {
            if (number >= NUM_MAX) return false;
            setNumber(number + 1);
            callback(data, number + 1, k, m);
        };

        const inputChange = (e: any) => {
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX || !Boolean(Number(v))) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v), k, m);
        };

        return (
            <div className="addSubtractor">
                <div className={number <= NUM_MIN ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    -
                </div>
                <input className="addSubtractor-number" value={number} onChange={inputChange} />
                <div className={number >= NUM_MAX ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    +
                </div>
            </div>
        );
    };

    const getAsynItem = async (item: any) => {
        const { productId, variantId, link_more } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    if (link_more && item?.children?.[0]) {
                        handleCalclate(item, item.children[0]);
                    }
                    item.discountPrice = res?.data?.price;
                    item.originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                    item.inventory = res?.data?.inventoryQuantity ?? undefined;
                    item.img = res?.data?.img || res?.data?.variantImg || item.img;
                    // item.img = res?.data?.variantImg || res?.data?.img || item.img;
                    // item.inventory = 1;
                    item.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;

                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        const tempSolarPanelsArr = JSON.parse(JSON.stringify(solarpanels));
        const solarPromises = tempSolarPanelsArr?.map((item: any) => getAsynItem(item));
        Promise.all(solarPromises)
            .then(() => {
                setSolarpanels(tempSolarPanelsArr?.filter((list: any) => list?.inventory !== undefined));
                setInit1(true);
            })
            .catch((e) => {
                console.error(e);
            });

        const resetGap = () => {
            const winW = window.innerWidth;
            if (winW >= 1440) {
                return setGap(24);
            } else if (winW > 1024) {
                return setGap(20);
            } else {
                return setGap(16);
            }
        };
        resetGap();
    }, []);

    useEffect(() => {
        if (init1) {
            const tempArr = JSON.parse(JSON.stringify(cards));

            const promises = tempArr?.map((item: any) => getAsynItem(item));
            Promise.all(promises)
                .then(() => {
                    setCardLists(tempArr?.filter((list: any) => list?.inventory !== undefined));
                    setInit2(true);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, [init1]);

    useEffect(() => {
        if (init1 && init2) {
            const tempArr = JSON.parse(JSON.stringify([...cardLists]));
            tempArr?.map((item: any, _: number) => {
                if (!item?.children) return;
                item.children = cloneDeep(item.children.map((child: any) => solarpanels.find((_item: any) => _item.id === child.id))).filter(
                    (item: any) => !!item,
                );
                item.children.forEach((item: any) => (item.isActive = false));
                item.children[0].isActive = true;
                item?.children?.map((child: any) => {
                    child.cartTitle = `${child?.cartTitle} (${item?.title})`;
                    child.parentVariantId = item?.variantId;
                    child.recommand = item.id !== 'T200' && getRecommand(item?.id, String(child?.id));
                    if (child?.inventory < 0) {
                        child.quantity = 0;
                    } else if (child?.recommand?.length > 0 && child?.inventory < child?.recommand[0]) {
                        child.quantity = child?.inventory;
                    } else {
                        child.quantity = child?.recommand?.length > 0 ? child?.recommand[0] : 0;
                    }
                });
                setSolarStatu(item, item?.children[0]);
                handleCalclate(item, item?.children[0]);
            });
            setCardLists(tempArr);
            setInit3(true);
        }
    }, [solarpanels, init1, init2]);

    useEffect(() => {
        const flag = solarpanels?.find((sp: any) => sp?.variantId === updateSolar?.variantId);
        if (updateSolar && flag) {
            const tempArr = JSON.parse(JSON.stringify([...cardLists]));
            const cardTargetIdx = tempArr?.findIndex((item: any) => item?.variantId === updateSolar?.parentVariantId);
            if (cardTargetIdx !== -1) {
                const solarTargetIdx = tempArr[cardTargetIdx]?.children.findIndex((item: any) => item?.variantId === updateSolar?.variantId);
                if (solarTargetIdx !== -1) {
                    tempArr[cardTargetIdx].children[solarTargetIdx]['quantity'] = updateSolar?.quantity;
                    setSolarStatu(tempArr[cardTargetIdx]);
                    handleCalclate(tempArr[cardTargetIdx], tempArr[cardTargetIdx]['children'][solarTargetIdx]);
                    setCardLists(tempArr);
                }
            }
        }
    }, [updateSolar]);

    return (
        <div id="vanlife-roadtrips-E" className={`outdoor-recreation-E outdoor-recreation-box inner ${css['outdoor-recreation-E']}`}>
            <h3 className="title">{t('secE_title')}</h3>
            {init1 && init2 && init3 && (
                <Swiper
                    className="cards swiper-box"
                    effect="fade"
                    spaceBetween={gap}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    modules={[Scrollbar, Navigation]}
                    navigation
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {cardLists?.map((card: any, k: number) => {
                        const isActiveChildIdx = card?.children?.findIndex((item: any) => item?.isActive);
                        return (
                            <SwiperSlide className={`card swiper-item item-${k + 1}`} key={k}>
                                <div className="main-product">
                                    <div className="card-img">
                                        {/* <EFPicture src={imgs?.[card?.id]?.[isActiveChildIdx]} alt={card?.title} /> */}
                                        <EcoImg pc={imgs?.[card?.id]?.[isActiveChildIdx]} />
                                    </div>
                                    <div className="card-info">
                                        <p className="card-power">{card?.power}</p>
                                        <p className="card-title">{card?.title}</p>
                                        <ul className="card-descs">
                                            {card?.descArr?.map((desc: any, m: number) => (
                                                <li className="card-desc" key={`${k}_${m}`}>
                                                    {t(desc)}
                                                </li>
                                            ))}
                                        </ul>
                                        {!open && (
                                            <span className="card-open" onClick={() => setOpen(true)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none">
                                                    <path
                                                        d="M1.5 1L4.5 4L7.5 1"
                                                        stroke="#626262"
                                                        strokeWidth="1.21739"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </span>
                                        )}
                                        {open && (
                                            <ul className="card-icons">
                                                {card?.icons?.map((item: any, m: number) => (
                                                    <li className="card-icon" key={`${k}_${m}`}>
                                                        <span className="icon-svg">{iconMap[item?.icon]}</span>
                                                        <div className="icon-info">
                                                            <p className="icon-day">
                                                                {t.rich(item?.title, {
                                                                    s: (text: string) => <span className="s">{text}</span>,
                                                                })}
                                                            </p>
                                                            <p className="icon-app">{t(item?.desc)}</p>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                                {card?.children?.length && (
                                    <div className={`sub-product sub-product-${card.id}`}>
                                        {card.id !== 'T200' && <p className="sub-title">{t('common_card_calculator')}</p>}
                                        {card.id !== 'T200' && (
                                            <div className={`sub-calc ${card?.statu === 2 ? 'not-recommand' : card?.statu === 0 ? 'zero' : ''}`}>
                                                <p className="calc-inner">
                                                    {card?.statu === 0
                                                        ? t.rich('common_card_0', {
                                                              storagePower: card?.storage,
                                                              s: (text: string) => <span className="s">{text}</span>,
                                                          })
                                                        : card?.statu === 2
                                                        ? t('common_card_no_recommand')
                                                        : t.rich('common_card_calculator_res', {
                                                              generatePower: card?.energy,
                                                              storagePower: card?.storage,
                                                              s: (text: string) => <span className="s">{text}</span>,
                                                          })}
                                                </p>
                                            </div>
                                        )}
                                        <div className="solar-panel first">
                                            <span className="sp-text">{card.id === 'T200' ? t('t200_common_card_sp_output') : t('common_card_sp_output')}</span>
                                            <ul className="sp-products">
                                                {card?.children?.map((list: any, m: number) => (
                                                    <li
                                                        className={`output-list ${list?.isActive ? 'active' : ''}`}
                                                        key={`${k}_${m}`}
                                                        onClick={() => handleClick(card, k, m)}
                                                    >
                                                        {list?.title}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="solar-panel">
                                            <span className="sp-text">
                                                {card.id === 'T200' ? t('t200_common_card_sp_quantity') : t('common_card_sp_quantity')}
                                            </span>
                                            <ul className="quantity-lists">
                                                {card?.children?.map((list: any, m: number) => (
                                                    <li className={`quantity-list ${list?.isActive ? 'show' : 'hide'}`} key={`${k}_${m}`}>
                                                        <AddSubtractor data={list} callback={handleCount} k={k} m={m} />
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}
                                <div className="card-btns">
                                    {card?.link_buy && (
                                        <>
                                            {Number(card?.inventory) <= 0 ? (
                                                <button disabled className={`btn-buy card-btn disable`}>
                                                    {t('common_card_out')}
                                                </button>
                                            ) : (
                                                <p className={`btn-buy card-btn`} onClick={() => init1 && init2 && init3 && handleBuy(card)}>
                                                    {t('common_card_buy')}
                                                </p>
                                            )}
                                        </>
                                    )}
                                    {card?.link_more && (
                                        <Link
                                            className="btn-more card-btn"
                                            href={`${card?.link_more}${
                                                String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                            }utm_source=scenario+page&utm_medium=Pillar`}
                                            target="_blank"
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'select_product',
                                                list_name: t('secF_title'),
                                                product_name: card.title,
                                                button_name: t('common_card_more'),
                                            }}
                                        >
                                            {t('common_card_more')}
                                        </Link>
                                    )}
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            )}
        </div>
    );
}
